import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token: string;
  domain = environment.apiURL;
  domainV2 = environment.apiURL;

  constructor(private router: Router, private http: HttpClient) {

  }

  createAuthenticationHeaders() {
    if (localStorage.getItem(environment.tokenKey)) {
      return { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': localStorage.getItem(environment.tokenKey) }) };
    }
    else {
      return { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    }
  }

  login(details : any) {
    return this.http.post(`${this.domainV2}users/login`, details);
  }

  forgotPassword(details : any) {
    details.bgColor = `#FF5722`
    return this.http.post(`${this.domain}users/forgotPassword`, details)
  }

  changePassword(details : any) {
    details.bgColor = `#FF5722`
    return this.http.post(`${this.domain}users/changePassword`, details, this.createAuthenticationHeaders())
  }

  checkEncryptedString(details : any) {
    return this.http.post(`${this.domain}users/checkEncryptedString`, details)
  }

  setNewPassword(details : any) {
    return this.http.post(`${this.domain}users/setNewPassword`, details)
  }

  getUserData(details : any) {
    return this.http.post(`${this.domain}users/me`, details, this.createAuthenticationHeaders())
  }


  //#region Trip

  trackTruck(details : any) {
    return this.http.post(`${this.domain}trips/trackTruck`, details);
  }

  createTrip(details : any) {
    return this.http.post(`${this.domain}trips/createTrip`, details, this.createAuthenticationHeaders())
  }

  getTrips(details : any) {
    return this.http.post(`${this.domain}trips/getTrips`, details, this.createAuthenticationHeaders())
  }

  deleteTrip(details : any) {
    return this.http.post(`${this.domain}trips/deleteTrip`, details, this.createAuthenticationHeaders())
  }

  editTrip(details : any) {
    return this.http.post(`${this.domain}trips/editTrip`, details, this.createAuthenticationHeaders())
  }
  closeTrip(details : any) {
    return this.http.post(`${this.domain}trips/closeTrip`, details, this.createAuthenticationHeaders())
  }

  approveTrip(details : any) {
    return this.http.post(`${this.domain}trips/approveTrip`, details, this.createAuthenticationHeaders())
  }

  addWebUnlockDetails(details : any) {
    return this.http.post(`${this.domain}trips/addWebUnlockDetails`, details, this.createAuthenticationHeaders())
  }

  addTripLocation(details : any) {
    return this.http.post(`${this.domain}trips/addLocationToTrip`, details, this.createAuthenticationHeaders())
  }

  addComments(details : any) {
    return this.http.post(`${this.domain}trips/addComments`, details, this.createAuthenticationHeaders())
  }

  getComments(details : any) {
    return this.http.post(`${this.domain}trips/getComments`, details, this.createAuthenticationHeaders())
  }

  getPayment(details : any) {
    return this.http.post(`${this.domain}trips/getPayment`, details, this.createAuthenticationHeaders())
  }

  getNoTrips(details : any) {
    return this.http.post(`${this.domain}trips/getNoTrips`, details, this.createAuthenticationHeaders())
  }

  addPayment(details : any) {
    return this.http.post(`${this.domain}trips/addPayment`, details, this.createAuthenticationHeaders())
  }

  getLocationPayments(details : any) {
    return this.http.post(`${this.domain}trips/getLocationPayments`, details, this.createAuthenticationHeaders())
  }

  getMarkersAllTripWise(details : any) {
    return this.http.post(`${this.domain}track/getMarkersAllTripWise`, details, this.createAuthenticationHeaders())
  }

  addDeviceToTrip(details : any) {
    return this.http.post(`${this.domain}trips/addDeviceToTrip`, details, this.createAuthenticationHeaders())
  }

  tripSendOTP(details : any) {
    return this.http.post(`${this.domain}trips/tripSendOTP`, details, this.createAuthenticationHeaders())
  }

  tripVerifyOTP(details : any) {
    return this.http.post(`${this.domain}trips/tripVerifyOTP`, details, this.createAuthenticationHeaders())
  }

  sendEmailToTeam(details : any) {
    return this.http.post(`${this.domain}trips/sendEmailToTeam`, details, this.createAuthenticationHeaders())
  }

  addFareDetailsWithoutTrip(details : any) {
    return this.http.post(`${this.domain}trips/addFareDetailsWithoutTrip`, details, this.createAuthenticationHeaders())
  }

  getOTPUnlockedDetails(details : any) {
    return this.http.post(`${this.domain}trips/getOTPUnlockedDetails`, details, this.createAuthenticationHeaders())
  }
  //#endregion Task

  //#region General
  uploadImage(details : any) {
    return this.http.post(`${this.domain}general/uploadImage`, details, this.createAuthenticationHeaders())
  }

  getImage(details : any) {
    return this.http.post(`${this.domain}general/getImage`, details, this.createAuthenticationHeaders())
  }

  getTansporters(details : any) {
    return this.http.post(`${this.domain}general/getTansporters`, details, this.createAuthenticationHeaders())
  }

  getMaterialType(details : any) {
    return this.http.post(`${this.domain}general/getMaterialType`, details, this.createAuthenticationHeaders())
  }

  downloadTrack(details : any) {
    return this.http.post(`${this.domain}general/downloadTrack`, details, this.createAuthenticationHeaders())
  }

  checkAvailibility(details : any) {
    return this.http.post(`${this.domain}general/checkAvailibility`, details, this.createAuthenticationHeaders())
  }
  //#endregion

  //#region Track
  getTrackData(details : any) {
    return this.http.post(`${this.domain}track/getTrackData`, details, this.createAuthenticationHeaders())
  }

  getTrackDataWithoutLogin(details : any) {
    return this.http.post(`${this.domain}track/getTrackDataWithoutLogin`, details)
  }

  getTrackDataWithoutAuth(details : any) {
    return this.http.post(`${this.domain}track/getTrackDataWithoutAuth`, details)
  }

  getGeofenceWithoutLogin(details : any) {
    return this.http.post(`${this.domain}geofences/getGeofenceWithoutLogin`, details)
  }
  //#endregion

  //#region Alert
  sendManualAlert(details : any) {
    return this.http.post(`${this.domain}alert/sendManualAlert`, details, this.createAuthenticationHeaders())
  }

  getAlertLogs(details : any) {
    return this.http.post(`${this.domain}alert/getAlertLogs`, details, this.createAuthenticationHeaders())
  }

  getReceivers(details : any) {
    return this.http.post(`${this.domain}alert/getReceivers`, details, this.createAuthenticationHeaders())
  }

  addReceivers(details : any) {
    return this.http.post(`${this.domain}alert/addReceivers`, details, this.createAuthenticationHeaders())
  }

  deleteReceiver(details : any) {
    return this.http.post(`${this.domain}alert/deleteReceiver`, details, this.createAuthenticationHeaders())
  }

  getEventsLogs(details : any) {
    return this.http.post(`${this.domain}general/getEventsLogs`, details, this.createAuthenticationHeaders())
  }

  checkAvailibilityWithoutTrip(details : any) {
    return this.http.post(`${this.domain}general/checkAvailibilityWithoutTrip`, details, this.createAuthenticationHeaders())
  }

  sendDataManually(details : any) {
    return this.http.post(`${this.domain}general/sendDataManually`, details, this.createAuthenticationHeaders())
  }

  //#endregion

  //#region geofence
  createGeofence(details : any) {
    return this.http.post(`${this.domain}geofences/createGeofence`, details, this.createAuthenticationHeaders())
  }

  getGeofence(details : any) {
    return this.http.post(`${this.domain}geofences/getGeofences`, details, this.createAuthenticationHeaders())
  }


  editGeofence(details : any) {
    return this.http.post(`${this.domain}geofences/editGeofence`, details, this.createAuthenticationHeaders())
  }

  deleteGeofence(details : any) {
    return this.http.post(`${this.domain}geofences/deleteGeofence`, details, this.createAuthenticationHeaders())
  }

  getCheckpoint(details : any) {
    return this.http.post(`${this.domain}geofences/getCheckpoints`, details, this.createAuthenticationHeaders())
  }

  getDistricts(details : any) {
    return this.http.post(`${this.domain}geofences/getDistricts`, details, this.createAuthenticationHeaders())
  }

  addDataForOTP(details : any) {
    return this.http.post(`${this.domain}geofences/addDataForOTP`, details, this.createAuthenticationHeaders())
  }

  saveRoute(details : any) {
    return this.http.post(`${this.domain}geofences/saveRoute`, details, this.createAuthenticationHeaders())
  }

  getRoute(details : any) {
    return this.http.post(`${this.domain}geofences/getRoutes`, details, this.createAuthenticationHeaders())
  }
  //#endregion

  //#region Asset

  //#region Permission

  getUserPermission(details : any) {
    return this.http.post(`${this.domain}permissions/getAllPermissions`, details, this.createAuthenticationHeaders())
  }

  //#endregion
  addAsset(details : any) {
    return this.http.post(`${this.domain}asset/addAsset`, details, this.createAuthenticationHeaders())
  }

  getAssetList(details : any) {
    return this.http.post(`${this.domain}asset/getAssets`, details, this.createAuthenticationHeaders())
  }

  getAssetType(details : any) {
    return this.http.post(`${this.domain}asset/getAssetType`, details, this.createAuthenticationHeaders())
  }

  deleteAsset(details : any) {
    return this.http.post(`${this.domain}asset/deleteAsset`, details, this.createAuthenticationHeaders())
  }

  editAssetDetails(details : any) {
    return this.http.post(`${this.domain}asset/editAssetDetails`, details, this.createAuthenticationHeaders())
  }

  addAssetDetails(details : any) {
    return this.http.post(`${this.domain}asset/addAssetDetails`, details, this.createAuthenticationHeaders())
  }

  bulkUploadAsset(details : any) {
    return this.http.post(`${this.domain}asset/bulkUpload`, details, this.createAuthenticationHeaders())
  }

  getCommands(details : any) {
    return this.http.post(`${this.domain}asset/getCommands`, details, this.createAuthenticationHeaders())
  }

  getCommand(details : any) {
    // this.domain +  
    return this.http.post(`${this.domain}asset/getLogsForCommand`, details, this.createAuthenticationHeaders());
  }

  //#endregion

  sendCommand(obj:any) {
    return this.http.post(`${this.domain}trips/sendDeviceCommand`, obj, this.createAuthenticationHeaders());
  }


  //#region 

  addUser(details : any) {
    return this.http.post(`${this.domain}user/addUser`, details, this.createAuthenticationHeaders())
  }

  addUserWithoutLogin(details : any) {
    return this.http.post(`${this.domain}user/addUserWithoutLogin`, details)
  }

  getUser(details : any) {
    return this.http.post(`${this.domain}user/getUsers`, details, this.createAuthenticationHeaders())
  }

  deleteUser(details : any) {
    return this.http.post(`${this.domain}user/deleteUser`, details, this.createAuthenticationHeaders())
  }

  linkUser(details : any) {
    return this.http.post(`${this.domain}user/linkUser`, details, this.createAuthenticationHeaders())
  }

  approveUser(details : any) {
    return this.http.post(`${this.domain}user/approveUser`, details, this.createAuthenticationHeaders())
  }

  updateUser(details : any) {
    return this.http.post(`${this.domain}user/updateUser`, details, this.createAuthenticationHeaders())
  }

  updateUserPermissions(details : any) {
    return this.http.post(`${this.domain}user/updateUserPermissions`, details, this.createAuthenticationHeaders())
  }

  sendOTP(details : any) {
    return this.http.post(`${this.domain}users/sendOTP`, details, this.createAuthenticationHeaders())
  }

  verifyOTP(details : any) {
    return this.http.post(`${this.domain}users/verifyOTP`, details, this.createAuthenticationHeaders())
  }

  //#endregion

  // #monitoring region
  getCountLocationWise(details : any) {
    return this.http.post(`${this.domain}monitoring/getCountLocationWise`, details, this.createAuthenticationHeaders())
  }

  updateAssetHelper(details : any) {
    return this.http.post(`${this.domain}monitoring/updateAssetHelper`, details, this.createAuthenticationHeaders())
  }

  getDataLocationWise(details : any) {
    return this.http.post(`${this.domain}monitoring/getDataLocationWise`, details, this.createAuthenticationHeaders())
  }
  getLocationStatusData(details : any) {
    return this.http.post(`${this.domain}monitoring/getLocationStatusData`, details, this.createAuthenticationHeaders())
  }
  deviceRunningWithoutTrip(details : any) {
    return this.http.post(`${this.domain}monitoring/deviceRunningWithoutTrip`, details, this.createAuthenticationHeaders())
  }

  updateLocationToDevice(details : any) {
    return this.http.post(`${this.domain}monitoring/updateLocationToDevice`, details, this.createAuthenticationHeaders());
  }

  getDeviceWiseStatus(details : any) {
    return this.http.post(`${this.domain}monitoring/getDeviceWiseStatus`, details, this.createAuthenticationHeaders());
  }

  getLocationWiseStatus(details : any) {
    return this.http.post(`${this.domain}monitoring/getLocationWiseStatus`, details, this.createAuthenticationHeaders());
  }
  // #endregion

  getMaharashtraTrips() {
    return this.http.get(`${this.domainV2}maharashtra/trips`, this.createAuthenticationHeaders());
  }

  copyLink(details: { tripID: string; deviceID: string | number }) {
    return this.http.post(
      `${this.domain}general/copyLink`,
      details,
      this.createAuthenticationHeaders()
    );
  }

  logout() {
    localStorage.removeItem(environment.tokenKey)
    this.router.navigate(['/']);
  }


}
